import { Outlet } from '@tanstack/react-router';
import { Moon, Sun } from 'lucide-react';

import { useTheme } from '@/shared/lib/useTheme';
import { t } from '@/shared/i18n';
import { Button } from '@/shared/ui/Button';

import { Backdrop } from './Backdrop';
import { Brand } from './Brand';
import styles from './PublicLayout.module.scss';

/**
 * Каркас открытых экранов: вход и приём приглашения.
 *
 * Только знак и переключатель темы. Боковое меню здесь было бы обещанием
 * разделов, по которым нельзя ходить.
 */
export function PublicLayout() {
  const { theme, toggle } = useTheme();

  return (
    <div className={styles['layout']}>
      <Backdrop />
      <header className={styles['header']}>
        <Brand />
        <Button
          iconOnly
          variant="ghost"
          tone="neutral"
          size="sm"
          onClick={toggle}
          aria-label={theme === 'dark' ? t.userMenu.themeLight : t.userMenu.themeDark}
        >
          {theme === 'dark' ? <Sun /> : <Moon />}
        </Button>
      </header>
      <main className={styles['content']}>
        <Outlet />
      </main>
    </div>
  );
}
